import { useCallback } from 'react';

import { useLocation } from 'react-router';

import { postTrackedDownload } from '@src/requests/trackedDownloads';

export const useTrackDownload = () => {
    const { pathname } = useLocation();
    const { search } = useLocation();

    const trackDownload = useCallback((resourceType, resourceId = null) => {
        const data = {
            resource_type: resourceType,
            resource_id: resourceId,
            referrer_path: pathname + search,
        };

        return postTrackedDownload(data).catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error tracking download:', error);
        });
    }, [pathname, search]);

    return { trackDownload };
};

